import { render } from "./MainAboutMenu.vue?vue&type=template&id=a52d5796&ts=true"
import script from "./MainAboutMenu.vue?vue&type=script&lang=ts"
export * from "./MainAboutMenu.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__